import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {ONGOING_OBLIGATIONS_OF_POSITION_1} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const OngoingObligationsOfPositions1 = "tfOngoingObligationsOfPositions1Question";

export function ongoingObligationsOfPositions1() {
    return {
        templateUrl: "app/quiz/fxe/questions/OngoingObligationsOfPositions1.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: OngoingObligationsOfPositions1Controller
    };
}

export class OngoingObligationsOfPositions1Controller extends FxeQuizQuestionController {
    public config = ONGOING_OBLIGATIONS_OF_POSITION_1;
}
